<template>
  <div id="home">
    <meta name="robots" content="noindex" />
    <kinesis-container event="move">
      <div id="banner-wrapper" class="container-fluid">
        <base-nav
          v-model="showMenu"
          :transparent="true"
          menu-classes="justify-content-center"
          class="navbar-horizontal navbar-main navbar-top navbar-dark"
          expand="md"
        >
          <template>
            <div class="navbar-collapse-header">
              <b-row>
                <b-col cols="12" class="collapse-close">
                  <button
                    type="button"
                    class="navbar-toggler"
                    @click="showMenu = false"
                  >
                    <span></span>
                    <span></span>
                  </button>
                </b-col>
              </b-row>
            </div>
            <b-navbar-nav class="menu-nav align-items-lg-center">
              <b-nav-item @click="scrollToElement('o-festival-wrapper')">
                <span class="nav-link-inner--text font-times">O FESTIVAL</span>
              </b-nav-item>
              <b-nav-item @click="scrollToElement('novos-talentos')">
                <span class="nav-link-inner--text font-times"
                  >NOVOS TALENTOS</span
                >
              </b-nav-item>
              <b-nav-item @click="scrollToElement('datas')">
                <span class="nav-link-inner--text font-times">DATAS</span>
              </b-nav-item>
              <b-nav-item to="/login">
                <span class="nav-link-inner--text font-times">INSCREVA-SE</span>
              </b-nav-item>
            </b-navbar-nav>
          </template>
        </base-nav>

        <div
          id="banner-content"
          class="d-flex justify-content-center align-items-center"
        >
          <b-row class="d-flex justify-content-center">
            <b-col
              md="3"
              lg="2"
              class="
                d-flex
                justify-content-center
                align-items-center
                px-md-3 px-lg-0
                pr-lg-4
              "
            >
              <kinesis-element
                type="translate"
                :strength="20"
                class="d-flex justify-content-center"
              >
                <img
                  id="banner-onde-os-astros"
                  src="@/assets/img/2021/banner-onde-os-astros.png"
                  alt="Onde os astros da comunicação se encontram"
                />
              </kinesis-element>
            </b-col>
            <b-col
              md="6"
              lg="5"
              class="
                d-flex
                justify-content-center
                align-items-center
                px-md-3 px-lg-3
              "
            >
              <img
                id="banner-mandala"
                src="@/assets/img/2021/banner-mandala.png"
                alt="Banner"
              />
            </b-col>
            <b-col
              cols="6"
              md="2"
              lg="2"
              class="
                d-flex
                justify-content-center
                align-items-center
                px-md-3 px-lg-5
              "
            >
              <kinesis-element type="translate" :strength="10">
                <router-link id="banner-inscreva-se" to="/login">
                  <img
                    src="@/assets/img/2021/banner-inscreva-se.png"
                    class="hover-scale"
                    alt="Inscreva-se"
                  />
                </router-link>
              </kinesis-element>
            </b-col>
          </b-row>
        </div>
      </div>
      <div id="o-festival-wrapper" ref="o-festival" class="container-fluid">
        <b-row>
          <b-col order="2" order-lg="1" cols="8" lg="6">
            <kinesis-element
              type="rotate"
              :strength="2"
              :originX="43"
              :originY="53"
            >
              <img
                id="festival-galo"
                src="@/assets/img/2021/festival-galo.png"
              />
            </kinesis-element>
          </b-col>
          <b-col
            order="1"
            order-lg="2"
            md="12"
            lg="6"
            class="d-flex align-items-center"
          >
            <div id="o-festival-text" class="ml-lg-6 my-7 mr-xl-6">
              <img
                class="img-titulo mb-4"
                src="@/assets/img/2021/festival-titulo.png"
                alt="O Festival"
              />
              <p class="text-white font-times font-italic font-weight-bold">
                Bom publicitário não fica contando com a sorte, <br />
                mas tá sempre de olho no futuro.
                <br /><br />
                Em 2021, previmos que muito do que a pandemia trouxe de novidade
                estaria ainda mais presente: as lives com conteúdo de qualidade,
                eventos 100% digitais ou híbridos e por aí vai. Por isso,
                decidimos mudar.
                <br /><br />
                Com as energias renovadas e buscando uma vibração mais
                sintonizada com os desejos do nosso público, no 31º Mídia
                Festival a premiação ganha ainda mais corpo e o conteúdo chega
                para trazer uma experiência inédita.
                <br /><br />
                Inscreva-se e aguarde. Esse futuro você não perde por esperar.
              </p>
              <kinesis-element type="translate" :strength="20">
                <img
                  id="festival-midia-festival"
                  class="img-titulo mt-4 hover-scale"
                  src="@/assets/img/2021/festival-midia-festival.png"
                />
              </kinesis-element>
            </div>
          </b-col>
        </b-row>
      </div>

      <div id="content-wrapper" class="container-fluid">
        <kinesis-element
          type="rotate"
          :strength="0.75"
          class="position-absolute"
        >
          <img
            id="novidades-card-a-sorte"
            class="mb-4 hover-scale"
            src="@/assets/img/2021/novidades-card-a-sorte.png"
          />
        </kinesis-element>
        <kinesis-element
          type="rotate"
          :strength="-0.5"
          class="position-relative"
          transformOrigin="top right"
        >
          <img
            id="novidades-cristal"
            class="mb-4 hover-scale"
            src="@/assets/img/2021/novidades-cristal.png"
          />
        </kinesis-element>
        <b-row class="d-flex justify-content-center pt-6">
          <b-col md="9" lg="5" class="d-flex flex-column align-items-center">
            <img
              class="img-titulo mb-4"
              src="@/assets/img/2021/novidades-titulo.png"
              alt="Novidades"
            />
            <p
              id="novidades-descricao"
              class="
                text-white
                font-times font-weight-bold font-italic
                text-center
              "
            >
              Os astros se alinharam, a sorte está lançada <br />e este ano
              vamos ter um festival diferente de tudo. <br /><br />
              Grandes nomes da comunicação, novas categorias para profissionais
              e a volta dos prêmios técnicos.
              <br /><br />
              Tem aquele trabalho que é o seu amuleto da sorte? Consulte os
              oráculos. <br />
              Quem sabe a carta que virará para você não é a do Galo Dourado?
              <br /><br />
              Quer saber todas as novidades para 2021? <br />
              Leia as cartas do nosso regulamento:
            </p>
            <router-link to="/cadastro">
              <img
                class="img-titulo my-4 hover-scale"
                id="novos-talentos"
                ref="novos-talentos"
                src="@/assets/img/2021/novidades-inscricoes-regulamento.png"
                alt="Regulamento"
              />
            </router-link>
          </b-col>
        </b-row>

        <b-row class="d-flex justify-content-center pb-8 mt-4 mt-lg-0">
          <b-col
            cols="12"
            lg="4"
            class="d-flex flex-column align-items-center pl-xl-4"
          >
            <img
              class="img-titulo mb-4"
              src="@/assets/img/2021/novos-talentos-titulo.png"
              alt="Novos Talentos 2021"
            />
            <p
              id="novos-talentos-descricao"
              class="
                text-white
                font-times font-weight-bold font-italic
                text-center
              "
            >
              Se você é aprendiz dos caminhos místicos da propaganda, trago boas
              novas.
              <br /><br />
              As inscrições para o maior festival de publicidade do interior
              paulista, o Mídia Festival, na categoria estudantil já estão
              abertas.
              <br /><br />
              Reúna seu grupo, siga as orientações do rergulamento e envie sua
              proposta no link abaixo.<br />
              Não é uma questão de sorte. O futuro aos trabalhos criativos
              pertence.<br />
              Inscreva-se djá!
            </p>
            <router-link to="/login" class="d-flex justify-content-center">
              <img
                id="novos-talentos-inscreva-se"
                class="mt-2 hover-scale"
                src="@/assets/img/2021/novos-talentos-inscreva-se.png"
              />
            </router-link>
          </b-col>
          <b-col cols="6" lg="3" class="d-flex flex-column align-items-center">
            <kinesis-element
              type="rotate"
              :strength="-1.5"
              class="position-relative z-index-1"
            >
              <img
                id="novos-talentos-card-o-aprendiz"
                class="hover-scale"
                src="@/assets/img/2021/novos-talentos-card-o-aprendiz.png"
              />
            </kinesis-element>
          </b-col>
          <b-col cols="6" lg="4" class="d-flex flex-column align-items-center">
            <kinesis-element
              type="rotate"
              :strength="1.5"
              class="position-relative z-index-1"
            >
              <img
                id="novos-talentos-deck"
                class="hover-scale"
                src="@/assets/img/2021/novos-talentos-deck.png"
              />
            </kinesis-element>
          </b-col>
        </b-row>

        <div class="position-relative">
          <img
            id="conteudo-transicao"
            src="@/assets/img/2021/conteudo-transicao.png"
          />
        </div>

        <b-row
          class="d-flex justify-content-center py-9"
          id="datas"
          ref="datas"
        >
          <b-col
            cols="6"
            lg="3"
            class="d-flex flex-column align-items-end pl-lg-7"
          >
            <img
              class="img-titulo-md mb-4"
              src="@/assets/img/2021/conteudo-titulo.png"
              alt="Conteúdo"
            />
            <p
              id="conteudo-descricao"
              class="text-white font-times font-weight-bold font-italic"
            >
              Magos da publicidade falando sobre os rumos do mercado, gurus da
              propaganda fazendo suas projeções e bruxos do marketing mostrando
              como encantar o público.
              <br /><br />
              Não perca oportunidades únicas e ocasiões mágicas para expandir
              sua mente. Acompanhe a programação nas nossas redes sociais.
            </p>
          </b-col>
          <b-col cols="6" lg="3" class="d-flex flex-column align-items-center">
            <img
              id="conteudo-estrela-direita"
              src="@/assets/img/2021/conteudo-estrela-direita.png"
            />
            <kinesis-element
              type="translate"
              :strength="-10"
              class="position-relative"
            >
              <img
                id="conteudo-card-o-evangelista"
                class="hover-scale"
                src="@/assets/img/2021/conteudo-card-o-evangelista.png"
              />
            </kinesis-element>
          </b-col>
          <b-col cols="6" lg="3" class="d-flex flex-column align-items-center">
            <img
              id="conteudo-estrela-esquerda"
              src="@/assets/img/2021/conteudo-estrela-esquerda.png"
            />
            <kinesis-element
              type="translate"
              :strength="10"
              class="position-relative"
            >
              <img
                id="conteudo-card-o-deadline"
                class="hover-scale"
                src="@/assets/img/2021/conteudo-card-o-deadline.png"
              />
            </kinesis-element>
          </b-col>
          <b-col cols="6" lg="3" class="d-flex flex-column align-items-start">
            <img
              class="img-titulo-sm mb-4"
              src="@/assets/img/2021/conteudo-datas.png"
              alt="Datas"
            />
            <div class="text-white font-times font-weight-bold font-italic">
              <div class="text-datas">30/08</div>
              <div class="text-datas-subtitle">Início das inscrições</div>
              <br />
              <div class="text-datas">15/10</div>
              <div class="text-datas-subtitle">Término das inscrições</div>
              <br />
              <div class="text-datas">05/11</div>
              <div class="text-datas-subtitle">Shortlist</div>
              <br />
              <div class="text-datas">24 e 25/11</div>
              <div class="text-datas-subtitle">Premiação</div>
            </div>
          </b-col>
        </b-row>
      </div>

      <div id="footer-wrapper" class="container-fluid bg-white py-6">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="text-uppercase font-bebas-neue big">Patrocinadores</h2>
          </div>
          <b-row class="mt-2">
            <b-col cols="12">
              <h3
                class="
                  font-bebas-neue
                  text-uppercase
                  mb-3
                  text-center text-xl-left
                "
              >
                Mantenedores Ouro:
              </h3>
              <div
                class="
                  mantenedores-wrapper
                  w-100
                  d-flex
                  flex-wrap
                  justify-content-center justify-content-xl-start
                "
              >
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/band-mais.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/old/eptv.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/old/g1.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/tv-thati-record.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/old/vtv-sbt.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-ouro/old/per4media.png"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-4">
            <b-col lg="12" xl="7">
              <h3
                class="
                  font-bebas-neue
                  text-uppercase
                  mb-3
                  mt-sm-4 mt-lg-0
                  text-center text-xl-left
                "
              >
                Mantenedores Prata:
              </h3>
              <div
                class="
                  mantenedores-wrapper
                  w-100
                  d-flex
                  flex-wrap
                  justify-content-center justify-content-xl-start
                "
              >
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/eletromidia.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/old/moohb.png"
                />
                <img
                  src="@/assets/img/patrocinadores/mantenedores-prata/old/rede-familia.png"
                />
              </div>
            </b-col>
            <b-col lg="12" xl="5">
              <h3
                class="
                  font-bebas-neue
                  text-uppercase
                  mb-3
                  mt-sm-4 mt-lg-0
                  text-center text-xl-left
                "
              >
                Mantenedores Bronze:
              </h3>
              <div
                class="
                  mantenedores-wrapper
                  w-100
                  d-flex
                  flex-wrap
                  justify-content-center justify-content-xl-start
                "
              >
                <img
                  src="@/assets/img/patrocinadores/mantenedores-bronze/as_logo_col.png"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col lg="12">
              <h3 class="font-bebas-neue big text-uppercase mb-3 text-center">
                Apoio:
              </h3>
              <div
                class="apoio-wrapper d-flex justify-content-around flex-wrap"
              >
                <img src="@/assets/img/patrocinadores/apoio/agencia-era.png" />
                <img src="@/assets/img/patrocinadores/apoio/old/antena-1.png" />
                <img src="@/assets/img/patrocinadores/apoio/band-fm.png" />
                <img src="@/assets/img/patrocinadores/apoio/band-multi.png" />
                <img
                  src="@/assets/img/patrocinadores/apoio/barini-de-santis-advogados.png"
                />
                <img src="@/assets/img/patrocinadores/apoio/benhur.png" />
                <img
                  src="@/assets/img/patrocinadores/apoio/old/campinas-em-revista.png"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/cidade-gospel.png"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/diario-campineiro.png"
                />
                <img src="@/assets/img/patrocinadores/apoio/dinamize.png" />
                <img src="@/assets/img/patrocinadores/apoio/educadora.png" />
                <img src="@/assets/img/patrocinadores/apoio/goon.png" />
                <img src="@/assets/img/patrocinadores/apoio/nativa.png" />
                <img
                  src="@/assets/img/patrocinadores/apoio/old/nova-brasil-thati.png"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/old/radio-bandeirantes2.png"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/radio-cbn-campinas.png"
                />
                <img
                  src="@/assets/img/patrocinadores/apoio/radio-central.png"
                />
                <img src="@/assets/img/patrocinadores/apoio/radio-cidade.png" />
                <img src="@/assets/img/patrocinadores/apoio/radio-laser.png" />
                <img
                  src="@/assets/img/patrocinadores/apoio/old/royal-midia.png"
                />
              </div>
            </b-col>
          </b-row>
          <b-row class="mt-5">
            <b-col lg="12">
              <h3 class="font-bebas-neue big text-uppercase mb-3 text-center">
                Comunicação:
              </h3>
              <div
                class="apoio-wrapper d-flex justify-content-around flex-wrap"
              >
                <img src="@/assets/img/patrocinadores/comunicacao/sala.png" />
              </div>
            </b-col>
          </b-row>
        </div>
      </div>

      <div id="footer-wrapper" class="container-fluid bg-gray-dark">
        <div class="container py-5">
          <b-row>
            <b-col sm="6" lg="4">
              <img
                id="logo-app"
                class="d-flex justify-content-end align-items-center"
                src="@/assets/img/2021/logo-app.png"
              />
            </b-col>
            <b-col
              sm="6"
              md="4"
              lg="6"
              class="d-flex justify-content-end align-items-center"
            >
              <p class="text-address text-white mb-0">
                Av. João Erbolato, 364 - Jd. Chapadão - Cep. 13070-070 -
                Campinas - SP - Fone: (19) 3255-1081
              </p>
            </b-col>
            <b-col
              md="2"
              lg="2"
              class="
                d-flex
                justify-content-center
                align-items-center
                justify-content-md-end
              "
            >
              <a href="https://www.facebook.com/appcampinas" target="_blank"
                ><img
                  class="social-media-logo"
                  src="@/assets/img/2021/facebook-logo.png"
              /></a>
              <a href="https://www.instagram.com/appcampinas" target="_blank"
                ><img
                  class="social-media-logo"
                  src="@/assets/img/2021/instagram-logo.png"
              /></a>
            </b-col>
          </b-row>
        </div>
      </div>
    </kinesis-container>
  </div>
</template>
<script>
import { BaseNav } from "@/components";

export default {
  components: {
    BaseNav,
  },
  data() {
    return {
      showMenu: false,
      menuTransitionDuration: 250,
      pageTransitionDuration: 200,
      year: new Date().getFullYear(),
    };
  },
  methods: {
    scrollToElement(refName) {
      document.getElementById(refName).scrollIntoView({
        behavior: "smooth",
      });
    },
    toggleNavbar() {
      document.body.classList.toggle("nav-open");
      this.showMenu = !this.showMenu;
    },
    closeMenu() {
      document.body.classList.remove("nav-open");
      this.showMenu = false;
    },
  },
  mounted() {
    function clickEffect(e) {
      var d = document.createElement("div");
      d.className = "clickEffect";
      d.style.top = e.clientY + "px";
      d.style.left = e.clientX + "px";
      document.body.appendChild(d);
      d.addEventListener(
        "animationend",
        function () {
          d.parentElement.removeChild(d);
        }.bind(this)
      );
    }
    var home = document.getElementById("home");
    home.addEventListener("click", clickEffect);
  },
  beforeRouteUpdate(to, from, next) {
    // Close the mobile menu first then transition to next page
    if (this.showMenu) {
      this.closeMenu();
      setTimeout(() => {
        next();
      }, this.menuTransitionDuration);
    } else {
      next();
    }
  },
};
</script>
<style lang="scss">
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

@font-face {
  font-family: "BebasNeue";
  src: url("~@/assets/fonts/BebasNeue-Regular.ttf");
}

li.nav-item::after {
  content: "|";
  position: relative;
  bottom: 2.75rem;
  color: white;
  right: 0.5rem;

  @include media-breakpoint-down(md) {
    bottom: 2rem;
  }
}

li.nav-item:first-child::after {
  visibility: hidden;
}

#banner-wrapper {
  min-height: 550px;
  background: url("~@/assets/img/2021/bg-banner.png") no-repeat top center;
  background-size: cover;
  padding-bottom: 100px;
}

#o-festival-wrapper {
  position: relative;
  min-height: 84vh;
  min-height: 800px;
  background: url("~@/assets/img/2021/bg-o-festival.png") no-repeat center
    center fixed;
  background-size: cover;
}

#content-wrapper {
  position: relative;
  background: url("~@/assets/img/2021/bg-content.png") no-repeat top center;
  background-size: cover;
}

#banner-content {
  height: 80%;

  img {
    width: 100%;
    max-height: 100%;
  }

  #banner-inscreva-se {
    min-width: 140px;
  }
  #banner-onde-os-astros {
    min-width: 200px;
  }

  @include media-breakpoint-down(sm) {
    #banner-onde-os-astros {
      width: 50%;
      margin-bottom: 50px;
    }
    #banner-inscreva-se {
      width: 50%;
    }
  }
}

#festival-galo {
  @include media-breakpoint-up(lg) {
    position: relative;
    width: 110%;
    top: -40px;
    right: 15px;
  }

  @include media-breakpoint-down(md) {
    position: relative;
    width: 110%;
    top: -40px;
    right: 166px;
    min-width: 370px;
  }
}

#festival-midia-festival {
  width: 60%;
  max-width: 300px;

  @include media-breakpoint-down(md) {
    position: absolute;
    right: 5%;
  }
}

#logo-app {
  width: 300px;

  @include media-breakpoint-down(md) {
    width: 100%;
  }
}

#novidades-descricao {
  position: relative;
  padding: 50px 18px;

  background: url("~@/assets/img/2021/novidades-frame.png") no-repeat top center;
  background-size: 100% 100%;

  @include media-breakpoint-down(md) {
    font-size: 0.9rem;
  }
}

#novos-talentos-descricao {
  position: relative;
  padding: 40px 60px 30px;

  background: url("~@/assets/img/2021/novos-talentos-frame.png") no-repeat top
    center;
  background-size: 100% 100%;

  @include media-breakpoint-down(lg) {
    font-size: 0.9rem;
    padding: 60px 30px 30px;
  }
}

#conteudo-descricao {
  position: relative;
  text-align: right;

  @include media-breakpoint-down(lg) {
    font-size: 0.9rem;
  }
  @include media-breakpoint-down(sm) {
    font-size: 0.8rem;
  }
}

#novidades-card-a-sorte {
  position: absolute;
  width: 400px;
  top: 50px;
  left: 3%;

  @include media-breakpoint-down(lg) {
    position: absolute;
    width: 300px;
    top: 120px;
    left: 3%;
  }

  @include media-breakpoint-down(md) {
    position: absolute;
    right: 2%;
    top: -400px;
    left: initial;
  }

  @include media-breakpoint-down(sm) {
    position: absolute;
    width: 220px;
    right: 5%;
    top: -280px;
    left: initial;
  }
}

#novidades-cristal {
  position: absolute;
  width: 400px;
  top: 200px;
  right: 0;

  @include media-breakpoint-down(md) {
    display: none;
  }

  @include media-breakpoint-down(lg) {
    position: absolute;
    width: 300px;
    top: 200px;
    right: 3%;
  }
}

#novos-talentos-inscreva-se {
  width: 80%;
}

.z-index-1 {
  z-index: 1;
}

#novos-talentos-card-o-aprendiz {
  z-index: 1;
  position: relative;
  width: 90%;
  min-width: 280px;
  top: 15%;

  @include media-breakpoint-down(md) {
    top: 10%;
    width: 90%;
    min-width: unset;
  }
}

#novos-talentos-deck {
  z-index: 1;
  position: relative;
  width: 90%;
  min-width: 380px;
  top: 23%;
  left: 0;

  @include media-breakpoint-down(md) {
    position: relative;
    top: 0;
    width: 120%;
    min-width: unset;
  }
}

#conteudo-card-o-evangelista {
  z-index: 1;
  position: relative;
  width: 99%;
}

#conteudo-card-o-deadline {
  z-index: 1;
  position: relative;
  width: 100%;
}

#conteudo-transicao {
  z-index: 0;
  position: absolute;
  top: -250px;
  width: 800px;
  left: 0;
  right: 0;
  margin: 0 auto;
  mix-blend-mode: soft-light;
}

#conteudo-estrela-direita {
  z-index: 0;
  position: absolute;
  top: 0;
  width: 600px;
  right: 20%;
  mix-blend-mode: soft-light;
}

#conteudo-estrela-esquerda {
  z-index: 0;
  position: absolute;
  top: 0;
  width: 500px;
  left: 40%;
  mix-blend-mode: soft-light;
}

.img-titulo {
  width: 300px;

  @include media-breakpoint-down(md) {
    width: 100%;
    max-width: 300px;
  }
}

.img-titulo-sm {
  width: 130px;
}

.img-titulo-md {
  width: 210px;

  @include media-breakpoint-down(md) {
    width: 100%;
    max-width: 210px;
  }
}

.mantenedores-wrapper img {
  align-self: center;
  max-height: 70px;
  max-width: 150px;
  margin: 10px 20px;
}

.apoio-wrapper img {
  align-self: center;
  max-height: 70px;
  max-width: 130px;
  margin: 5px 5px;
}

.social-media-logo {
  height: 25px;
  margin-left: 15px;
}

@media (min-width: 1400px) {
  .container {
    max-width: 1340px;
  }
}

img {
  image-rendering: -moz-crisp-edges; /* Firefox        */
  image-rendering: -o-crisp-edges; /* Opera          */
  image-rendering: -webkit-optimize-contrast; /* Safari         */
  image-rendering: optimize-contrast; /* CSS3 Proposed  */
  -ms-interpolation-mode: nearest-neighbor; /* IE8+           */
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
  user-drag: none;
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

.hover-scale {
  transition: transform 200ms;

  &:hover {
    transform: scale(1.03);
  }
}

.font-bebas-neue {
  font-family: "BebasNeue", Arial, Helvetica, sans-serif;
  font-size: 1.6em;
  &.big {
    font-size: 2em;
  }
}

.text-datas {
  font-size: 2.4em;
}

.text-address {
  font-size: 0.9em;
}

.text-datas-subtitle {
  line-height: 0.9em;
  font-size: 1.2em;
}

.menu-nav {
  font-size: 1.1em;
}

div.clickEffect {
  position: fixed;
  box-sizing: border-box;
  border-style: solid;
  border-color: #b9a886;
  border-radius: 50%;
  animation: clickEffect 0.4s ease-out;
  z-index: 99999;
}

@keyframes clickEffect {
  0% {
    opacity: 0.6;
    width: 0em;
    height: 0em;
    margin: -0.25em;
    border-width: 0.5em;
  }
  100% {
    opacity: 0.1;
    width: 10em;
    height: 10em;
    margin: -5em;
    border-width: 0.03em;
  }
}
</style>
